import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form"
  ];

  connect() {
    this.token = document.querySelector(
      'meta[name="csrf-token"]'
    ).content;
  }

  onSubmit(event) {
    event.preventDefault();
  }

  onChange() {
    const formData = new FormData(this.formTarget);
    fetch(this.formTarget.action, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': this.token,
      },
      body: formData,
    })
    .then (response => response.text())
    .then(html => window.Turbo.renderStreamMessage(html));
  }
}
